import { splitRegionNames } from '../../../../../../utils/packages';
import { Tooltip, UIText1 } from '@cian/ui-kit';
import * as React from 'react';
import { getTitle } from './utils';
import { useSelector } from 'react-redux';
import { selectBuyPackageModalData } from '../../../../../../selectors/buyPackageModal';
import { ListItem } from '../ListItem';

const MAX_REGION_NAMES = 2;

export const RegionsContainer = () => {
  const data = useSelector(selectBuyPackageModalData);

  const { regionNames } = data;

  const { firstRegionNames, restRegionNames } = splitRegionNames(regionNames, MAX_REGION_NAMES);

  const title = getTitle(regionNames);

  const content = (
    <>
      {firstRegionNames.join(', ')}

      {restRegionNames.length > 0 && (
        <Tooltip placement="top-end" theme="white" title={restRegionNames.join(', ')}>
          <UIText1 color="fill_primary_active_100" display="inline">
            ещё {restRegionNames.length}
          </UIText1>
        </Tooltip>
      )}
    </>
  );

  return <ListItem title={title} content={content} />;
};
